import styled from '@emotion/styled';
import React from 'react';
import { useParams, useLocation } from 'react-router-dom';

import UserNavigationMenu from '../settings/user-navigation-menu';

import { useDashboardDataContext } from '~/client/components/project/dashboard/dashboard-context';
import { LeftNavMenu } from '~c/components/base/left-nav';
import {
  candidateModelAssessmentReportRouteUtil,
  aiSystemAssessmentReportRouteUtil,
  functionalModelAssessmentReportRouteUtil,
  vendorModelAssessmentReportRouteUtil,
  vendorAgentAssessmentReportRouteUtil,
  useDashboardHandlers,
  dashboardRouteUtil,
} from '~c/routes';

interface Props {
  className?: string;
}

const ReportGenerationLeftNavImpl: React.FC<Props> = ({ className }) => {
  const { candidateId, functionalModelId, vendorModelId, vendorAgentId } =
    useParams();
  const location = useLocation();
  const { navigateToMainDashboard } = useDashboardHandlers();
  const { project } = useDashboardDataContext();
  const dashboardHelper = dashboardRouteUtil.useHelper();
  const routePrefix = React.useMemo(() => {
    if (vendorModelId) {
      return vendorModelAssessmentReportRouteUtil.routePrefix;
    }
    if (vendorAgentId) {
      return vendorAgentAssessmentReportRouteUtil.routePrefix;
    }
    if (candidateId) {
      return candidateModelAssessmentReportRouteUtil.routePrefix;
    }
    if (functionalModelId) {
      return functionalModelAssessmentReportRouteUtil.routePrefix;
    }
    return aiSystemAssessmentReportRouteUtil.routePrefix;
  }, [candidateId, functionalModelId, vendorModelId, vendorAgentId]);

  // Handle back navigation based on source
  const handleBackNavigation = () => {
    // Check if we came from tasks page via location state
    if (location.state && location.state.from === 'tasks') {
      return dashboardHelper.navigateTo('TASKS');
    }
    // Default behavior: go back to main dashboard
    return navigateToMainDashboard(
      candidateId,
      functionalModelId,
      undefined,
      vendorModelId,
      vendorAgentId,
      project?.projectType
    );
  };

  return (
    <LeftNavMenu
      className={className}
      name={routePrefix}
      header={{
        showBackButton: true,
        onClick: handleBackNavigation,
      }}
    >
      <UserNavigationMenu />
    </LeftNavMenu>
  );
};

const ReportGenerationLeftNav = styled(ReportGenerationLeftNavImpl)`
  .grow {
    flex-grow: 1;
  }
`;

export default ReportGenerationLeftNav;
